import { omit } from "@common/helpers/objects";
import {
    FinancialDocumentExtended,
    FinancialDocumentListItem,
} from "@common/types/financialDocument";

const DETAIL_ONLY_EXTENDED_FIELDS = [
    "accountInfoExtraction",
    "balanceSheetExtraction",
    "coaExtraction",
    "glExtraction",
    "linkedJournalEntries",
    "linkedInvoices",
    "linkedBills",
] as const;

export function projectFinancialDocumentListItem(
    document: FinancialDocumentExtended,
): FinancialDocumentListItem {
    const {
        documentInvoicesExtraction,
        documentBillsExtraction,
        integrationAccount,
        ...sharedFields
    } = omit(document, ...DETAIL_ONLY_EXTENDED_FIELDS);

    return {
        ...sharedFields,
        integrationAccount: integrationAccount
            ? {
                  id: integrationAccount.id,
                  financialAccountId:
                      integrationAccount.financialAccountId ?? null,
              }
            : null,
        documentInvoicesExtraction: documentInvoicesExtraction
            ? { status: documentInvoicesExtraction.status }
            : null,
        documentBillsExtraction: documentBillsExtraction
            ? { status: documentBillsExtraction.status }
            : null,
    };
}
